import React from 'react';
import PaytmIcon from '../../atoms/icons/paytm-new';
import SimplIcon from '../../atoms/icons/simpl';
import Loader from '../../atoms/icons/loader';
import { formatPrice, syndicatedSource } from '../../../helpers/utils';
import './payment-options.m.css';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { sendProductDetail, trackAddToCart, trackCheckout } from '../../../helpers/datalayer-utils';

class PaymentOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datalayerFields: {
        name: get(this.props.assetPlan, ['duration_unit'], ''),
        id: get(this.props.assetPlan, ['id'], ''),
        price: get(this.props.assetPlan, ['price_cents'], 0) / 100,
        brand: get(this.props.story, ['story-template'], 'text'),
        category: 'Micro Plan',
        variant: 'NA',
        quantity: '1',
        dimension7: 'NA',
        dimension11: 'Logged In',
        dimension12: 'Banner',
        dimension13: 'Bottom Sticky',
        dimension14: 'NA',
        dimension15: get(this.props.story, ['headline'], ''),
        dimension16: get(this.props.story, ['story-template'], 'text'),
        dimension17: get(this.props.story, ['sections', '0', 'name'], ''),
        dimension18: 'NA',
        dimension19: get(this.props.story, ['author-name'], ''),
        dimension20: get(this.props.story, 'tags', [])
          .map(t => t.name)
          .join(' | '),
        dimension21: syndicatedSource(this.props.story)
      }
    };
  }
  componentDidMount() {
    this.props.setUser();
    sendProductDetail(this.state.datalayerFields);
  }
  render() {
    const {
      appliedCoupon,
      assetPlan,
      setAppliedCoupon,
      isLoading,
      paymentOptions,
      selectedWallet
    } = this.props;
    const price = assetPlan
      ? formatPrice(assetPlan.price_cents / 100, assetPlan.price_currency, 'en-IN', 0)
      : '';
    const discountedPrice = appliedCoupon
      ? formatPrice(
          get(appliedCoupon, ['discount_details', 'discounted_price_cents']) / 100,
          assetPlan.price_currency,
          'en-IN',
          0
        )
      : '';
    return (
      <React.Fragment>
        <div styleName="micropayment-wrapper" id="micropayment-skin">
          <h2 styleName="subscribe-headline">
            {appliedCoupon
              ? `Offer Applied. Pay ${discountedPrice} to read this story.`
              : `Pay ${price} and read this story`}
          </h2>
          {!selectedWallet && <p styleName="subscribe-summary">Choose method of payment:</p>}
          {appliedCoupon && (
            <div styleName="applied-coupon">
              <p styleName="coupon-display">
                {get(appliedCoupon, ['discount_details', 'code'], '')} APPLIED
              </p>
              <button styleName="clearBtn" onClick={() => setAppliedCoupon(null)} />
            </div>
          )}
          {isLoading ? (
            <div styleName="loader">
              <Loader color={'#000'} />
            </div>
          ) : (
            <div styleName={`icons-wrapper ${appliedCoupon ? 'reduced-padding' : ''}`}>
              {paymentOptions &&
                paymentOptions.paytm &&
                (!selectedWallet || selectedWallet === 'paytm') && (
                  <span
                    styleName="payment-button"
                    onClick={event => {
                      event.target.disabled = true;
                      this.props.pay('paytm');
                      trackAddToCart(this.state.datalayerFields);
                      trackCheckout(this.state.datalayerFields);
                    }}
                    data-testid="paytm-button"
                  >
                    <div styleName="paytm-icon-wrapper">
                      {selectedWallet && this.props.isLoading ? <Loader /> : <PaytmIcon />}
                    </div>
                  </span>
                )}
              {paymentOptions &&
                paymentOptions.simpl &&
                (!selectedWallet || selectedWallet === 'simpl') && (
                  <span
                    styleName="payment-button"
                    onClick={() => {
                      this.props.pay('simpl');
                      trackAddToCart(this.state.datalayerFields);
                      trackCheckout(this.state.datalayerFields);
                    }}
                    data-testid="simpl-button"
                  >
                    <div styleName="simpl-icon-wrapper">
                      <SimplIcon />
                    </div>
                  </span>
                )}
              {(!selectedWallet || selectedWallet === 'juspay') && (
                <span
                  styleName="payment-button"
                  onClick={() => {
                    this.props.pay('juspay');
                    trackAddToCart(this.state.datalayerFields);
                    trackCheckout(this.state.datalayerFields);
                  }}
                  data-testid="others-button"
                >
                  <span styleName="others-button">Others</span>
                </span>
              )}
            </div>
          )}
          <p
            styleName="apply-coupon"
            onClick={this.props.showApplyVoucher}
            data-testid="apply-coupon"
          >
            {appliedCoupon ? 'Would you like to revisit coupon codes?' : 'Apply Coupon'}
          </p>
          <span styleName="update-number">
            To change your number{' '}
            {this.props.mobileNumber && (
              <span styleName="mobile-number">{this.props.mobileNumber},</span>
            )}
            <a
              styleName="update-number-link"
              onClick={() => this.props.changeNumber()}
              data-testid="update-number"
            >
              Click here
            </a>
          </span>
        </div>
      </React.Fragment>
    );
  }
}

PaymentOptions.propTypes = {
  showApplyVoucher: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  paymentOptions: PropTypes.objectOf(PropTypes.any).isRequired,
  pay: PropTypes.func.isRequired,
  appliedCoupon: PropTypes.object,
  setAppliedCoupon: PropTypes.func,
  assetPlan: PropTypes.shape({
    price_cents: PropTypes.number,
    price_currency: PropTypes.string,
    duration_unit: PropTypes.string,
    id: PropTypes.number
  }),
  story: PropTypes.shape({
    'story-template': PropTypes.string,
    headline: PropTypes.string,
    sections: PropTypes.array,
    tags: PropTypes.array,
    'author-name': PropTypes.string
  }),
  selectedWallet: PropTypes.string,
  mobileNumber: PropTypes.string,
  changeNumber: PropTypes.func.isRequired
};

export default PaymentOptions;
